// React
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// Utilities
import { saveNewVendor } from "../../../Redux/Actions/vendorActions";
import { getVendorsViaPin } from "../../../Request/VendorRequests";
import mapPin from "../../../img/location-icon1.png";
import logoIcon from "../../../img/LOGO.svg";
import VernacBtn from "./VernacBtn";
import HomePageSearchBtn from "../../Search/HomePageSearchBtn";
export default function TitleBar() {
  const dispatch = useDispatch();
  const userAddress = useSelector((state) => state.user?.address);

  const current = useSelector((state) => state.user.currentLocation);
  const vendors = useSelector((state) => state.vendor.vendorList);

  const primaryAddress = useMemo(() => {
    return userAddress?.filter((address) => {
      if (address?.primary) {
        return true;
      }
    })[0];
  }, [userAddress]);

  useEffect(() => {
    let presentData = vendors?.map((el) => el.vendorId);
    getVendorsViaPin(current?.pincode, presentData?.length ? presentData : [""])
      .then((res) => (res?.length ? dispatch(saveNewVendor(res)) : ""))
      .catch((err) => console.log(err));
  }, [current, dispatch, vendors]);

  return (
    <div>
      <nav
        className="navbar nav-header"
        style={{
          padding: "10px 15px 26px",
          background: "linear-gradient(180deg, #9C2F46 0%, #D45F66 100%)",
        }}
      >
        <div className="d-flex w-100">
          <div className="w-100">
            <div className="lh-sm d-flex justify-content-between align-items-center">
              <a
                href="/home"
                className="d-flex align-items-center text-decoration-none"
              >
                <img
                  src={logoIcon}
                  alt=""
                  width={24}
                  className="d-block"
                  style={{ marginRight: "4px" }}
                />
                <h1
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#fff",
                    margin: "0",
                  }}
                >
                  Rashan
                </h1>
                {/* {current?.name || current?.area} */}
              </a>
              <div
                className="text-light d-flex align-items-center"
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  fontSize: "12px",
                  padding: "4px 8px",
                  marginRight: "-8px",
                }}
                // onClick={() => document.getElementById("updatePin").click()}
                data-bs-toggle="offcanvas"
                data-bs-target="#selectArea"
              >
                <img
                  src={mapPin}
                  alt=""
                  width={16}
                  className="d-block"
                  style={{ marginRight: "4px" }}
                />
                {primaryAddress ? (
                  <>
                    {primaryAddress?.area}
                    {primaryAddress?.city !== "NA" ? (
                      <>, {primaryAddress.city}</>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ". . . "
                )}
                <i
                  className="bi bi-chevron-down"
                  style={{ marginLeft: "4px" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div
        className="d-flex w-100"
        style={{
          marginTop: "-18px",
          position: "relative",
          zIndex: "1030",
          padding: "0 15px",
        }}
      >
        {/* ------------------Search-------------------------- */}

        <HomePageSearchBtn />

        {/* -------------------VERNEC BUTTON----------------------------- */}
        <VernacBtn />
      </div>
    </div>
  );
}
